export default __webpack_public_path__ + "static/media/auditCompletedIcon.031783a5.svg";